import PartnerOffersWidget from './PartnerOffersWidget';

export default PartnerOffersWidget;
